import { FC } from "react";
import { StyleProp, ViewStyle } from "react-native";
import { Circle, Color, G, Path, Svg } from "react-native-svg";

const MoneyDollarCircle: FC<{ color?: Color; style?: StyleProp<ViewStyle> }> = ({ color, style }) => (
  <Svg style={style} viewBox="0 0 17 17" fill="none">
    <G stroke={color || "#000"}>
      <Circle cx={8.5} cy={8.5} r={8} />
      <Path
        d="M8.603 4.662c.98 0 1.779.798 1.779 1.78a.262.262 0 0 0 .523 0 2.305 2.305 0 0 0-2.04-2.287V3.062a.262.262 0 1 0-.524 0v1.093A2.305 2.305 0 0 0 6.3 6.44a2.305 2.305 0 0 0 2.302 2.302c.98 0 1.779.798 1.779 1.78 0 .98-.799 1.778-1.78 1.778a1.78 1.78 0 0 1-1.778-1.779.262.262 0 1 0-.524 0c0 1.181.894 2.156 2.04 2.287v1.082a.262.262 0 1 0 .524 0v-1.082a2.305 2.305 0 0 0 2.04-2.287A2.305 2.305 0 0 0 8.603 8.22a1.78 1.78 0 0 1-1.779-1.78c0-.98.799-1.778 1.78-1.778Z"
        fill={color || "#000"}
        strokeWidth={0.5}
      />
    </G>
  </Svg>
);

export default MoneyDollarCircle;
